module.exports = __webpack_public_path__ + "assets-cabinet/img/change-pin-icon.8b5f2fc6.svg";